module.exports = __webpack_public_path__ + "img/p4.eda0b59a.png";